class Modal {
  constructor() {
    this.dialog = null;
    this.close = null;
    // this.dialogContent = this.dialog.querySelector('.modal-content-wrap');
    this.modalToggles = document.querySelectorAll('.lot-selector-area[data-id]');
    this.delegatedModalToggles = '.lot-selector-btn[data-id]:not(.favorite-lot)';
    this.delegatedModalHubSpotActions = '[data-hs-action]';
    this.delegatedModalActions = 'a[href]';
    this.loadingClass = 'loading';
    this.restUrl = `${wpApiSettings.root}unit-selector/v1/`;
    this.originalPageTitle = document.title;
  }

  init() {
    this.modalToggles.forEach((modalToggle) => {
      modalToggle.addEventListener('click', (e) => {
        e.preventDefault();
        const { id, title, lotType } = modalToggle.dataset;
        this.openDialog(id, title, lotType);
      });
    });

    this.constructor.delegateEvent('click', document, this.delegatedModalToggles, (e) => {
      e.preventDefault();
      const { id, title } = e.target.dataset;
      this.openDialog(id, title);
    });

    this.constructor.delegateEvent('click', document, this.delegatedModalHubSpotActions, (e) => {
      this.constructor.sendHubSpotAction(e);
    });

    this.constructor.delegateEvent('click', document, this.delegatedModalActions, () => {
      this.closeDialog();
    });
  }

  openDialog(id, title, lotType) {
    this.setDialog(id, title, lotType);
    
    // Open the dialog
    this.dialog.showModal();

    // Init gallery
    this.initDialogGallery();

    // Fetch the content and fill the dialog
    // this.fillDialog(id, title, lotType);
  }

  setDialog(id, title, lotType) {
    this.dialog = document.querySelector(`.lot-modal[data-id="${id}"]`);
    const close = this.dialog.querySelector('.modal-close');
    document.title = `${title} | ${this.originalPageTitle}`; // Human readable title

    this.constructor.sendHubSpotPageView(id, title, lotType);

    close.addEventListener('click', () => {
      this.closeDialog();
    });

    this.dialog.addEventListener('close', () => {
      // Set original page title
      document.title = this.originalPageTitle;
    });
  }

  fillDialog(id, title, lotType) {
    const action = 'get-lot-modal-content';
    const request = new Request(`${this.restUrl}${action}`, {
      method: 'POST',
      body: JSON.stringify({
        id,
        lotType,
      }),
    });

    // Fill the dialog with the retrieved content
    this.initLoadingFeedback();
    fetch(request)
      .then(response => response.text())
      .then((content) => {
        this.dialogContent.innerHTML = content;
        this.initDialogGallery();
        this.constructor.sendHubSpotPageView(id, title, lotType);
        document.title = `${title} | ${this.originalPageTitle}`; // Human readable title
      })
      .catch((error) => {
        /* eslint-disable-next-line no-console */
        console.error('Error loading content:', error);
      })
      .finally(() => {
        // Small timeout to prevent FOUC when styling gets applied
        setTimeout(() => {
          this.closeLoadingFeedback();
        }, 100);
      });
  }

  initLoadingFeedback() {
    this.dialog.classList.add(this.loadingClass);
  }

  closeLoadingFeedback() {
    this.dialog.classList.remove(this.loadingClass);
  }

  closeDialog() {
    this.dialog.close();
  }

  initDialogGallery() {
    const gallery = this.dialog.querySelector('.modal-gallery');

    if (gallery && window.LSGallery) {
      new window.LSGallery(gallery).init();
    }
  }

  static sendHubSpotPageView(id, title, lotType) {
    /* eslint-disable no-underscore-dangle */
    if (!window._hsq) return;

    const prevTitle = document.title;

    // HubSpot readable title
    document.title = title;

    const path = `/${lotType}/${id}`;

    _hsq.push(['setPath', path]);
    _hsq.push(['trackPageView']);

    // Reset document title
    document.title = prevTitle;
  }

  static sendHubSpotAction(e) {
    /* eslint-disable no-underscore-dangle */
    if (!window._hsq) return;

    const prevTitle = document.title;

    // Set document title before tracking the pageview
    document.title = `${e.target.dataset.hsAction} || ${e.target.dataset.hsValue}`;
    _hsq.push(['setPath', '/']);
    _hsq.push(['trackPageView']);

    // Reset document title
    document.title = prevTitle;
  }

  static delegateEvent(eventType, ancestorElement, targetElementSelector, listenerFunction) {
    ancestorElement.addEventListener(eventType, (event) => {
      if (event.target && event.target.matches && event.target.matches(targetElementSelector)) {
        (listenerFunction)(event);
      }
    });
  }
}

window.addEventListener('load', () => {
  /* eslint-disable no-new */
  new Modal().init();
});
